export function searchWithFilter() {
	document.querySelector('.js-job-search-form').submit();
}

export function getBrowserLocation(callBackFn) {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(
			function(pos) {
				callBackFn({
					latitude: pos.coords.latitude,
					longitude: pos.coords.longitude,
				});
			},
			err => errorCallBack(callBackFn, err),
		);
	} else {
		callBackFn();
	}
}

export function isSubstring(str_1, str_2) {
	return str_1.toUpperCase().includes(str_2.toUpperCase());
}

function errorCallBack(callBackFn, error) {
	switch (error.code) {
		case error.TIMEOUT:
			callBackFn();
			break;
		case error.PERMISSION_DENIED:
			if (error.message.indexOf('Only secure origins are allowed') == 0) {
				tryAPIGeolocation(callBackFn);
			} else {
				callBackFn();
			}
			break;
		case error.POSITION_UNAVAILABLE:
			if (error.message.indexOf('Origin does not have permission to use Geolocation service') == 0) {
				tryAPIGeolocation(callBackFn);
			} else {
				callBackFn();
			}
			break;
		default:
			callBackFn();
	}
}

function tryAPIGeolocation(callBackFn) {
	$.post(`https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBbw67pa9iZWG5gtHsG3m0ITFxZGu65WWs`, function(
		success,
	) {
		callBackFn({
			latitude: success.location.lat,
			longitude: success.location.lng,
		});
	}).fail(function() {
		callBackFn();
	});
}

const KEY = {
	ENTER: 13,
};

export function isEnterKey(event) {
	if (!event) return;
	const nodeName = event.target.nodeName;
	const key = event.keyCode;
	return key === KEY.ENTER && nodeName !== 'TEXTAREA' && nodeName !== 'BUTTON';
}
